// add hyphens to the SSN
export const formatSSN = value => {
  const newValue = value?.slice(0, 11)?.replace(/-/g, '')
  if (newValue?.length <= 3) {
    return newValue
  }
  if (newValue?.length > 3 && newValue?.length <= 5) {
    return `${newValue?.slice(0, 3)}-${newValue?.slice(3)}`
  }
  if (newValue?.length > 5) {
    return `${newValue?.slice(0, 3)}-${newValue?.slice(3, 5)}-${newValue?.slice(
      5
    )}`
  }
}

// mask SSN with X, but keep the last 4 digits visible
export const maskSSN = v => {
  const masked = v?.slice(0, 7)?.replace(/[0-9]/g, 'X')
  const final = masked + v?.slice(7)
  return final
}


export const ssnDisplayValue = ({ ssn, ssnLast4 }) => {
  if (!ssn) {
    return ssnLast4 ? `XXX-XX-${ssnLast4}` : null
  }
  return maskSSN(formatSSN(ssn))
}